import AgreementInfo from './AgreementInfo';

export default AgreementInfo;
